import { Directive, inject, input, OnInit } from '@angular/core';
import { combineLatest, filter, map, switchMap } from 'rxjs';
import { RequestsApiService } from '@core/services/request/requests-api.service';
import { FormPickerComponent } from '@core/components';
import { toObservable } from '@angular/core/rxjs-interop';

@Directive({
  selector: 'x-form-picker[xAttachInstallers]',
  standalone: true,
})
export class AttachInstallersDirective implements OnInit {
  private readonly requestAPIService = inject(RequestsApiService);
  private readonly component = inject(FormPickerComponent);
  readonly $contractorId = input.required<number>({
    alias: 'contractorId',
  });
  readonly $contractorSubdivisionId = input.required<number>({
    alias: 'contractorSubdivisionId',
  });
  readonly contractorId$ = toObservable(this.$contractorId);
  readonly contractorSubdivisionId$ = toObservable(
    this.$contractorSubdivisionId,
  );

  ngOnInit() {
    // combineLatest, а не zip: при смене только подразделения zip ждал новой пары
    // значений и список оставался от прежнего подразделения
    this.component.items$ = combineLatest([
      this.contractorId$,
      this.contractorSubdivisionId$,
    ]).pipe(
      filter(conditions => conditions.every(Boolean)),
      switchMap(([contractorId, contractorSubdivisionId]) =>
        this.requestAPIService.getInstallersForClientAndContractor$(
          null,
          contractorId,
          contractorSubdivisionId,
        ),
      ),
      map(installers => installers.map(({ personId }) => personId)),
    );
  }
}
